<template>
  <div id="xgplayer" class="xgplayer"></div>
</template>

<script>
import Player from 'xgplayer'
import HlsPlugin from 'xgplayer-hls.js'
// import 'xgplayer/dist/index.min.css'

export default {
  name: 'Xgplayer',
  props: {
    url: {
      type: String,
      default: ''
    },
    urlHigh: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      xgplayer: null
    }
  },
  computed: {
    videoArr () {
      const { url, urlHigh } = this
      return { url, urlHigh }
    }
  },
  watch: {
    videoArr: {
      handler (newVal) {
        this.$nextTick(() => {
          const { url, urlHigh } = newVal
          if (urlHigh || url) {
            this.xgplayer.src = urlHigh || url
            this.xgplayer.destroy()
            this.initPlayer()
            // this.xgplayer.reload()
          }
        })
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.initPlayer()
  },
  beforeDestroy () {
    if (this.xgplayer) this.xgplayer.destroy()
  },
  methods: {
    initPlayer () {
      const config = {
        id: 'xgplayer',
        url: this.url || this.urlHigh,
        defaultQuality: this.url || this.urlHigh,
        fluid: true, // 设置为流式布局，可使播放器宽度跟随父元素的宽度大小变化，且高度按照配置项中的高度和宽度的比例来变化（播放器宽高未设置时按照内部默认值来计算）
        playbackRate: [0.5, 0.75, 1, 1.5, 2],
        defaultPlaybackRate: 1,
        autoplay: this.autoplay,
        loop: false,
        poster: this.poster,
        lastPlayTime: 0, // 视频起播时间（单位：秒）
        pip: false, // 画中画
        playsinline: this.isAppleDevice(), // IOS设备设置，防止被浏览器劫持
        'x5-video-player-type': 'h5', // 微信内置浏览器设置，防止被浏览器劫持
        'x5-video-orientation': 'portraint',
        definitionActive: 'click'
        // isLive: false
        // cors: true
        // plugins: [HlsPlugin]
      }

      if (this.urlHigh.includes('.m3u8') || this.url.includes('.m3u8')) {
        this.xgplayer = new HlsPlugin(config)
        if (this.url && this.urlHigh) {
          const urlArr = !this.url
            ? [{ name: '高清', url: this.urlHigh }]
            : [
              { name: '高清', url: this.urlHigh },
              { name: '标清', url: this.url }
            ]
          this.xgplayer.emit('resourceReady', urlArr)
        }
      } else {
        this.xgplayer = new Player(config)
        const urlArr = !this.url
          ? [{ name: '高清', url: this.urlHigh }]
          : [
            { name: '高清', url: this.urlHigh },
            { name: '标清', url: this.url }
          ]
        this.xgplayer.emit('resourceReady', urlArr)
      }

      if (this.xgplayer) {
        this.xgplayer.on('ready', () => {
          // 仅在 m3u8 且 url 和 urlHigh 都存在时执行
          if (
            (this.urlHigh && this.url) &&
            (this.urlHigh.includes('.m3u8') || this.url.includes('.m3u8'))
          ) {
            let tryCount = 0
            const setDefText = () => {
              const defBtn = document.querySelector('.xgplayer-definition .name')
              if (defBtn) {
                defBtn.innerText = this.url ? '标清' : '高清'
              } else if (tryCount < 100) {
                tryCount++
                setTimeout(setDefText, 100)
              }
            }
            setDefText()
          }
        })
        this.xgplayer.on('play', () => {
          const defBtn = document.querySelector('.xgplayer-definition .name')
          console.log('写入', defBtn)
          this.$emit('onVideoPlay')
        })
        this.xgplayer.on('pause', res => {
          this.$emit('onVideoPause')
        })
        this.xgplayer.on('ended', res => {
          this.$emit('triggerEvent', 'ended')
        })
        this.xgplayer.on('timeupdate', res => {
          // console.log(res)
          this.$emit('triggerEvent', 'timeupdate')
        })
        this.xgplayer.on('playbackrateChange', res => {
          this.$emit('triggerEvent', 'playbackrateChange')
        })
        this.xgplayer.on('definitionChange', res => {
          this.$emit('definitionChange', res)
        })
        this.xgplayer.on('error', res => {
          console.log('----cuowu', res)
        })
      }
    },
    isAppleDevice () {
      const ua = navigator.userAgent.toLowerCase()
      return /iphone|ipad|phone|Mac/i.test(ua)
    }
  }
}
</script>

<style lang="scss">
.xgplayer .xg-inner-controls {
  bottom: 10px;
}
.xgplayer .btn-text span {
  padding: 3px;
  background: none;
}
.xgplayer xg-icon .xgplayer-icon {
  font-size: 20px;
}
.xgplayer .xg-options-list { // 选择框
  font-size: 20px;
  li {
    padding: 12px 0;
  }
  li:nth-child(1) {
    margin-top: 0;
  }
}
.xgplayer.xgplayer-mobile .xgplayer-time { // 进度条文字
  font-size: 20px;
}

.xgplayer {
  border-radius: 8px;
}
</style>
